import {
  isLanguageRolledOut,
  LANGUAGE_OPTIONS,
  type LanguageValue,
} from '@/lib/languages'
import type { SupportedLanguage } from '@/lib/test-harness/types'

export { isLanguageRolledOut, LANGUAGE_OPTIONS }
export type { LanguageValue }

/**
 * Can the user EXECUTE `language` right now (Run/Submit enabled, dropdown
 * selectable)? Two layers (LG-247):
 *   1. Global rollout kill-switch (lib/languages.ts) — language is turned
 *      on at all. Removing a language there is the one-line rollback.
 *   2. Per-problem artifact availability — `availableLanguages` from
 *      problems.getTestConfig via ProblemContext. `null` means exactly
 *      "test config still loading": the gate degrades to rollout-only and
 *      the server enforces both layers regardless. Raw execution, which
 *      uses no per-problem artifacts, calls isLanguageRolledOut directly
 *      instead.
 *
 * Type predicate: a passing language is a member of the execution
 * pipeline's SupportedLanguage set, so callers can hand it to execution
 * APIs without asserting.
 */
export function isExecutionEnabled(
  language: LanguageValue,
  availableLanguages: readonly string[] | null,
): language is LanguageValue & SupportedLanguage {
  if (!isLanguageRolledOut(language)) return false
  if (availableLanguages === null) return true
  return availableLanguages.includes(language)
}
